import { render, staticRenderFns } from "./draw-button.vue?vue&type=template&id=9415acb2&scoped=true"
import script from "./draw-button.vue?vue&type=script&lang=js"
export * from "./draw-button.vue?vue&type=script&lang=js"
import style0 from "./draw-button.vue?vue&type=style&index=0&id=9415acb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9415acb2",
  null
  
)

export default component.exports